// src/components/ErrorBoundary.js

import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state to display fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Log error details
        this.setState({ error, errorInfo: info });
        // console.error("Error occurred:", error);
        // console.error("Error info:", info);
    }

    render() {
        if (this.state.hasError) {
            // Customize error display
            return <h1>Something went wrong. Please try again later.</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
